export const useNumberMaskName = 'useNumberMask';
export const usePhoneMaskName = 'usePhoneMask';
export const useRegExpMaskName = 'useRegExpMask';
export const useSSNMaskName = 'useSSNMask';
export const useZipCodeMaskName = 'useZipCodeMask';
